<template>
  <b-modal
    id="reason-refused-annonce"
    ref="modal"
    centered
    class="full-screen-modal"
    hide-footer
    hide-header
    ok-variant="primary">
    <div>
      <div class="col-12 custom-col-12 ">
        <div id="container-title-modal">
          <span class="page-title">
            <i class="ph-custom ph-x-circle main-red-color custom-size-icon-refused-annonce"/>
          </span>
        </div>
      </div>
      <div class=" custom-col-12 mt-2 ">
        <div>
          <span class="page-title">
            {{ $t("annonce.refused.annonce") }}
          </span>
        </div>
      </div>
      <p id="custom-p-modal-reason-refused" class="mt-3" v-html="$t('annonce.refused.reason.content')"></p>

      <div class="row justify-content-start col-12 mt-2">
        <div class="col-12">
          <ul>
            <li v-if="reason.hasOwnProperty('identityValidated') && !reason.identityValidated">{{ $t('identity.file') }}</li>
            <li v-if="reason.hasOwnProperty('carteGriseValidated') && !reason.carteGriseValidated">{{ $t('carte.grise') }}</li>
            <li v-if="reason.hasOwnProperty('plainteValidated') && !reason.plainteValidated">{{ $t('annonce.depotPlainte') }}</li>
            <li v-if="reason.hasOwnProperty('detailsValidated') && !reason.detailsValidated">{{ $t('annonce.context.robbery') }}</li>
            <li v-if="reason.hasOwnProperty('photosValidated') && !reason.photosValidated">{{ $t('annonce.images') }}</li>
          </ul>
        </div>
      </div>

      <p v-if="reason.hasOwnProperty('commentaire') && reason.commentaire"
         class="commentary-lamp mt-3"
         v-html="$t('annonce.refused.commentaire.lamp',{ commentaire : reason.commentaire})"></p>

    </div>
  </b-modal>
</template>

<script>
export default {
  name: "AnnonceReasonRefusedModal",

  props: {
    reason: {
      required: true,
      type: Object
    }
  },


}
</script>

<!-- not scoped car modal -->
<style>
#reason-refused-annonce .modal-content,
#reason-refused-annonce .modal-body {
  background-color: var(--main-black-dark) !important;
  border-radius: 15px;
}

#reason-refused-annonce .modal-body {
  padding: 0 !important;
}

#reason-refused-annonce #container-title-modal {
  padding-bottom: 1em;
  border-bottom: 1px solid var(--main-grey-dark);
  display: flex;
  justify-content: center;
}

#reason-refused-annonce #custom-p-modal-reason-refused,
#reason-refused-annonce .commentary-lamp {
  margin-bottom: 0;
  color: var(--main-grey-medium);
}

#reason-refused-annonce .custom-size-icon-refused-annonce {
  font-size: 60px;
}

</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceReasonRefusedModal.vue